import { DOCS_LINKS_ENABLED } from "@/src/constants/docs-links";
import { Callout } from "@/src/components/ui/callout";
import { Button } from "@/src/components/ui/button";
import Link from "next/link";
import { Bot } from "lucide-react";

const DOCS_HREF =
  "https://monitering.entellica.online/docs/api-and-data-platform/features/agent-skill";

/**
 * Informational, dismissible banner that highlights Entellica's support for AI
 * coding agents via the Agent Skill, MCP server, and CLI. Rendered on the
 * organization overview page.
 */
export function AgentToolsBanner() {
  return (
    <Callout
      className="mb-4"
      id="agent-tools-banner:v1"
      variant="info"
      align="middle"
      actions={() =>
        DOCS_LINKS_ENABLED ? (
          <Button asChild size="sm" variant="secondary">
            <Link href={DOCS_HREF} target="_blank">
              Learn more
            </Link>
          </Button>
        ) : null
      }
    >
      <div className="flex items-center gap-2">
        <Bot className="h-4 w-4 shrink-0" />
        <span>
          <span className="font-bold">
            Entellica works great with your AI coding agents.
          </span>{" "}
          Connect Claude Code, Codex, and other agents to your data with the
          Entellica Agent Skill, MCP server, and CLI.
        </span>
      </div>
    </Callout>
  );
}
